import {
  AntiSpamSection,
  AntiSpoofingSection,
  BlackListSection,
  ExchangeAntimalwareExclusionRule,
  ExchangeAntimalwareRule,
  ExchangeAntimalwareScanTask,
  ExchangeAntimalwareSection,
  ExchangeAntispamRule,
  ExchangeContentControlAttachmentFilteringRule,
  ExchangeContentControlFilteringRule,
  ExchangeContentControlSection,
  QuarantineSection,
} from '@nirvana/shared/dtos/types/policies/common';
import { ExtJsFilter } from '../../../../../../grid/utils/filters/types';

export interface ExchangeProtectionGeneralFormValue {
  uiSettings: {
    exchange: {
      blackList: BlackListSection;
      quarantine: QuarantineSection;
      antispoofing: AntiSpoofingSection;
    };
  };
}

export interface ExchangeProtectionAntispamFormValue {
  uiSettings: { exchange: { antispam: AntiSpamSection } };
}

export interface ExchangeAntimalwareFormValue {
  uiSettings: { exchange: { antimalware: ExchangeAntimalwareSection } };
}
export interface ExchangeContentControlFormValue {
  uiSettings: { exchange: { contentControl: ExchangeContentControlSection } };
}
export interface ExchangeAntimalwareRuleFormValue extends ExchangeAntimalwareRule {
  defaultPositionInGrid: number;
}
export interface ExchangeAntimalwareExclusionFormValue extends ExchangeAntimalwareExclusionRule {
  defaultPositionInGrid: number;
}
export interface ExchangeAntimalwareScanTaskFormValue extends ExchangeAntimalwareScanTask {
  defaultPositionInGrid: number;
}
export interface ExchangeContentControlFilteringRuleFormValue extends ExchangeContentControlFilteringRule {
  defaultPositionInGrid: number;
}

export interface ExchangeAntispamRuleFormValue extends ExchangeAntispamRule {
  defaultPositionInGrid: number;
}

export interface ExchangeContentControlAttachmentFilteringRuleFormValue
  extends ExchangeContentControlAttachmentFilteringRule {
  defaultPositionInGrid: number;
}

export enum ExchangeGeneralKeywords {
  General = 'General',
  UserGroups = 'UserGroups',
  DomainIpCheck = 'DomainIpCheck',
  DeleteQuarantinedFiles = 'DeleteQuarantinedFiles',
  ConnectionBlacklist = 'ConnectionBlacklist',
}

export enum ExchangeAntispamKeywords {
  Antispam = 'Antispam',
  AntispamFiltering = 'AntispamFiltering',
  Settings = 'Settings',
  RblSettings = 'RblSettings',
  DnsIpAddress = 'DnsIpAddress',
  DnsQueryTimeout = 'DnsQueryTimeout',
  WhiteList = 'WhiteList',
}

export enum ExchangeAntimalwareSearchableKeywords {
  Antimalware = 'Antimalware',
  AntimalwareFiltering = 'AntimalwareFiltering',
  EditNotes = 'EditNotes',
  Exclusions = 'Exclusions',
  ScanTasks = 'ScanTasks',
  OnDemandScanCredentials = 'OnDemandScanCredentials',
}
export enum ExchangeContentControlSearchableKeywords {
  ContentControl = 'ContentControl',
  ContentFiltering = 'ContentFiltering',
  Exclusions = 'Exclusions',
  TrustedSenders = 'TrustedSenders',
  TrustedRecipients = 'TrustedRecipients',
  ExcludeEmail = 'ExcludeEmail',
  AttachmentFiltering = 'AttachmentFiltering',
  Settings = 'Settings',
  ReplacementText = 'ReplacementText',
}

export enum USER_GROUPS_TYPE {
  CUSTOM = 1,
  AD = 2,
}

export enum ExchangeUserGroupStatus {
  ENABLED = 1,
  DISABLED = 0,
}

export interface GetSummaryRequest<ColumnKeys extends string> {
  filter: Array<ExtJsFilter<ColumnKeys>>;
  limit?: number;
  page?: number;
  sort?: string | null;
  dir?: string | null;
}
